<template>
  <div>
    <ul class="Fuell-Tabs">
      <li
        v-for="section in sections"
        :key="section.id"
        class="Fuell-Tabs--tab"
      >
        <router-link
          :to="{name:section.anchor.name}"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{ path: section.key }"
        ></router-link>
      </li>
    </ul>
    <router-view :expenses="true"></router-view>
  </div>
</template>

<script>
import { USER_CARDS_TYPE } from '@/constants/userCardsType'
import { OFFICE_CARDS_TYPE } from '@/constants/officeCardsType'

const sections = [
  {
    key: 'transactions',
    needs_card: true,
    subsections: [
      {
        id: 1,
        key: 'transactions_transactions_subsection_charged',
        anchor: { name: 'my_charged_transactions' }
      },
      {
        id: 2,
        key: 'transactions_transactions_subsections_authorizations',
        anchor: { name: 'my_authorizations_transactions' }
      },
      {
        id: 3,
        key: 'transactions_transactions_subsections_declined',
        anchor: { name: 'my_declined_transactions' }
      }

    ]
  },
  {
    key: 'reimbursements',
    subsections: [
      {
        id: 1,
        key: 'transactions_transactions_subsections_history',
        anchor: { name: 'my_history_reimbursements' }

      },
      {
        id: 2,
        key: 'transactions_transactions_subsection_pending',
        anchor: { name: 'my_pending_reimbursements' }

      }

    ]
  }
]
export default {
  name: 'ExpensesIndex',
  computed: {
    userWithoutCards () {
      return this.$store.getters['UsersStore/userLogged'].userCardsType === USER_CARDS_TYPE.USER_CARDS_WITHOUT
    },
    officeWithoutCards () {
      return this.$store.getters['CompanyStore/currentCompany'].officeCardsType === OFFICE_CARDS_TYPE.OFFICE_CARDS_WITHOUT
    },
    sections () {
      let subsections
      sections.forEach(item => {
        if (this.$route.meta.subpage === item.key && (!item.needs_card || (!this.officeWithoutCards && this.userWithoutCards && (this.isAdmin || this.isBookKeeper) && item.needs_card) || (!this.officeWithoutCards && !this.userWithoutCards))) {
          subsections = item.subsections
        }
      })
      return subsections
    },
    expenses () {
      return this.$store.getters['TransactionsStore/expenses']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    }
  }

}

</script>
